import React from 'react';
import { Modal, Input, message, Spin, Radio } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import { getMatchOption } from '../../shared/selectFn';
import { lowerToUpper } from '../../shared/formatElem';
import "../style.less"

const RadioGroup = Radio.Group;

const Config = {
    VPApproval:{
        title:'审批提前上岗',
        approvalStatus:'提前上岗审批结论',
        uploadType: 'ADVANCE_WORK',
        url:API_URL.contract.vpApprovalAdvanceDuty,
    },
    approval:{
        title:'负责人审批新建项目',
        approvalStatus:'审批结论',
        uploadType: 'ADVANCE_WORK',
        url:API_URL.contract.approvalPrincipalCreateInvestigation,
    },
    approvalSecond:{
        title:'负责人审批新建项目',
        approvalStatus:'审批结论',
        uploadType: 'CONTRACT',
        url:API_URL.contract.approvalPrincipalCreateInvestigation,
    }
}
class ApproveAdvanceWork extends React.Component {
    state = {
        loading: false,
        visible: false,
        saveParams: {},
        fileList: [],
        canViewEvaluate: false,
        config:{
            title:'',
            approvalStatus:'',
        },
    }

    show = (params, type) => {
        this.setState({
            visible: true,
            saveParams: {},
            canViewEvaluate: false,
            config:{ type, ...Config[type] },
            params: {...params},
        }, () => {
            this.loadFileList();
            this.loadEvaluateAuthority();
        });
    }

    hide = () => {
        this.setState({
            loading: false,
            visible: false,
            saveParams: {},
            fileList: [],
            canViewEvaluate: false,
            config:{},
        });
    }

    loadEvaluateAuthority = () => {
        const { params: { evaluateRecordId } } = this.state;
        if (!evaluateRecordId) {
            return;
        }
        const options = {
            method: 'post',
            url: API_URL.contract.judgeEvaluateCodeAuthority,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ canViewEvaluate: !!res.data });
            }
        };
        $.sendRequest(options);
    }

    loadFileList = () => {
        const { params: { jdeApplyId }, config } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: config.uploadType,
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = index;
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { params: { jdeApplyId }, saveParams, config } = this.state;
        const {
            approvalStatus,
            comments,
        } = saveParams;
        if (!approvalStatus) {
            message.warning(`请选择${config.approvalStatus}`);
            return;
        }
        if (approvalStatus == 'DISAGREE' && !comments) {
            message.warning('请输入审批不通过原因');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: config.url,
            data: {
                jdeApplyId,
                ...saveParams,
                status:approvalStatus,
                remark:comments,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, field) => {
        const { saveParams } = this.state;
        const value = e.target.value;
        saveParams[field] = value;
        if (field == 'approvalStatus' && value == 'AGREE') {
            saveParams.comments = '';
        }
        this.setState({ saveParams });
    }

    showEvaluateView = (params) => {
        const { evaluateCode, evaluateRecordId, quotationType } = params;
        if (!evaluateRecordId) {
            message.warning('未找到该临床评估单号对应的评估记录');
            return;
        }
        sessionStorage.evaluateRecordId = evaluateRecordId;
        sessionStorage.evaluateCode = evaluateCode;
        sessionStorage.quotationType = quotationType;
        window.open(`./#/clinicalEvaluation/ViewPage`);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    getDataList = () => {
        const { businessList } = this.props;
        const {
            params = {},
            saveParams,
            fileList,
            config,
            canViewEvaluate,
        } = this.state;
        const {
            jdeApplySceneId,
            jdeApplyIsInvestigationExists,
            investigationName,
            contractOrLetterIsSignShow,
            relationJdeCode,
            natureOfContractShow,
            sponsorName,
            contractSignCompanyName,
            investigationIdentifyCode,
            customerProjectCode,
            customerCompanyName,
            customerJdeCode,
            expectContractAmount,
            contractRelationSiteComment,
            havePaperContractShow,
            lineOfBusiness,
            lineOfBusinessString,
            belongingToUnit,
            currencyCode,
            exchangeRate,
            currencyName,
            signingUnit,
            investigationAreaName,
            diseaseName,
            investigationMedicineName,
            researchProductTypeShow,
            investigationByStageName,
            investigationByStageRemark,
            initialExpectContractAmount,
            baName,
            baCode,
            actualExpenseFee,
            actualFee,
            taxationFee,
            contractAmount,
            isRealitySettle,
            realitySettleShow,
            isDiscountTermValidity,
            isMsaSpecialContractReduce,
            msaSpecialContractReduceShow,
            discountContractAmount,
            discountContractAmountNoTaxValue,
            contractStartDateShow,
            contractEndDateShow,
        } = params;
        const { approvalStatus, comments } = saveParams;

        const asterisk = <span style={{color: 'red'}}>*</span>;

        const isInvestigationExists = jdeApplyIsInvestigationExists == '1';
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        const showSecondLine = (secondLineList || []).length > 0;
        const isRealitySettleed = isRealitySettle === 0;
        const isMsaSpecialContractReduceed = (params.isMsaSpecialContractReduce || params.isMsaSpecialContractReduce===0)? params.isMsaSpecialContractReduce== 1:isMsaSpecialContractReduce==1;// MSA特殊优惠从合同额中扣减
        const isDiscountTermValidityed = params.CustomChange? params.isDiscountTermValidity == 1: isDiscountTermValidity == 1;// 优惠有效期内
        // 税率
        let rate = '';
        if ((taxationFee || taxationFee === 0) && (contractAmount || contractAmount === 0)) {
            if (contractAmount - taxationFee == 0) {
                if (contractAmount === 0) {
                    rate = 0;
                } else {
                    rate = 100;
                }
            } else {
                rate = taxationFee / (contractAmount - taxationFee) * 100;
                rate = Number.isNaN(rate) ? '' : myFixed(rate,2);
            }
        }

        function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }

        return (
            <div>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">系统中是否有此项目</label>
                        <span className="ui-text">
                            {isInvestigationExists ? '是' : '否'}
                        </span>
                    </div>
                </li>
                {
                    isInvestigationExists &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">项目简称</label>
                            <span className="ui-text">{investigationName}</span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">此项目是否为临床项目</label>
                        <span className="ui-text">{params.isClinicalProjectShow}</span>
                    </div>
                </li>
                {
                    !isInvestigationExists && params.isClinicalProject == 1 &&
                    <div>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">业务机会编号</label>
                                <span className="ui-text">{params.businessOpportunityNum}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">临床评估单号</label>
                                <span className="ui-text">
                                    {
                                        canViewEvaluate ?
                                        <a onClick={e => this.showEvaluateView(params)}>{params.evaluateCode}</a>
                                        :
                                        <span>{params.evaluateCode}</span>
                                    }
                                </span>
                            </div>
                        </li>
                    </div>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">合同或函证是否签署</label>
                        <span className="ui-text">{contractOrLetterIsSignShow}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">合同性质</label>
                        <span className="ui-text">
                            {natureOfContractShow}
                        </span>
                    </div>
                </li>
                {
                    isInvestigationExists == '1' &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">关联JDE</label>
                            <span className="ui-text">{relationJdeCode}</span>
                        </div>
                    </li>
                }
                <div>
                    <li className="preview-item">
                        {/* <div className="item">
                            <label className="ui-label">申办方</label>
                            <span className="ui-text">{sponsorName}</span>
                        </div> */}
                        <div className="item">
                            <label className="ui-label">合同签署方</label>
                            <span className="ui-text">{contractSignCompanyName}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">项目识别码</label>
                            <span className="ui-text">{investigationIdentifyCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">项目编号</label>
                            <span className="ui-text">{customerProjectCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">客户全名</label>
                            <span className="ui-text">{customerCompanyName}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">客户JDE号</label>
                            <span className="ui-text">{customerJdeCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">BA</label>
                            <span className="ui-text">{format('joint', baName, baCode)}</span>
                        </div>
                    </li>
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">研究产品类型</label>
                                <span className="ui-text">{researchProductTypeShow}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目分期</label>
                                <span className="ui-text">{investigationByStageRemark ? `${investigationByStageName}(${investigationByStageRemark})` : investigationByStageName}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">疾病</label>
                                <span className="ui-text">{diseaseName}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">疾病分类</label>
                                <span className="ui-text">{params.diseaseClassName}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目领域</label>
                                <span className="ui-text">{investigationAreaName}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">受试者类型</label>
                                <span className="ui-text">{params.testeeTypeName}</span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">业务线</label>
                            <span className="ui-text">{lineOfBusinessString}</span>
                        </div>
                    </li>
                    {
                        showSecondLine &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">执行业务线二级分类</label>
                                <span className="ui-text">{params.secondLineNames}</span>
                            </div>
                        </li>
                    }
                    {
                        jdeApplySceneId == 1 &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目分类</label>
                                <span className="ui-text">{params.investigationTypeName}</span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">合同签署单位</label>
                            <span className="ui-text">{signingUnit}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">收入归属单位</label>
                            <span className="ui-text">{belongingToUnit}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">币种</label>
                            <span className="ui-text">{currencyName ? `${currencyName}(${currencyCode})` : ''}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">汇率</label>
                            <span className="ui-text">{exchangeRate}</span>
                        </div>
                    </li>
                    {
                        config.type == 'approvalSecond' && 
                        <div>
                            <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">合同额含税/人民币</label>
                                        <span className="ui-text">
                                            {contractAmount && `${contractAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} &nbsp;元
                                        </span>
                                    </div>
                                </li>
                                {lowerToUpper(contractAmount, 245)}
                        </div>
                    }
                    {
                        config.type == 'approvalSecond' &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">合同税率</label>
                                <span className="ui-text">{rate} %</span>
                            </div>
                        </li>
                    }
                    {
                        config.type == 'approvalSecond' &&
                        <div className='jde-rate'>
                            <div className="jde-top">
                                <div className="left lable" style={{width:'10%',textAlign:'center',borderRight:0}}>其中<br/>需扣除</div>
                                <div className="right jde-left" style={{width:'90%'}}>
                                    <div className="jde-bottom">
                                        <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/人民币</div>
                                        <div className="right text-com" style={{width:'50%'}}>
                                            {format('money', actualExpenseFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                    <div className="jde-bottom">
                                        <div className="left lable" style={{width:'50%'}}>实报实销税费/人民币</div>
                                        <div className="right text-com" style={{width:'50%'}}>
                                            {format('money', actualFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                    <div className="jde-bottom">
                                        <div className="left lable" style={{width:'50%'}}>合同额税费/人民币</div>
                                        <div className="right text-com" style={{width:'50%'}}>
                                            {format('money', taxationFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        config.type !== 'approvalSecond' &&
                        <div>
                            {
                                currencyCode === 'CNY' ?
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">预计合同金额/人民币</label>
                                        <span className="ui-text">
                                            {format('money', expectContractAmount)}&nbsp;元
                                        </span>
                                    </div>
                                </li>
                            :
                                <div className="jde-rate">
                                    <div className="left" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>预计合同金额/原币</div>
                                        <div className="right text-com" style={{width:'50%'}}>
                                        {format('money', initialExpectContractAmount)}&nbsp;{currencyName}
                                        </div>
                                    </div>
                                    <div className="right" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>预计合同金额/人民币</div>
                                        <div className="right text-com" style={{width:'50%'}}>
                                            {format('money', initialExpectContractAmount, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
                {
                    config.type == 'approvalSecond' &&
                    <div>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">是否据实结算</label>
                                <span className="ui-text">{realitySettleShow}</span>
                            </div>
                        </li>
                        {
                            (isRealitySettleed && isDiscountTermValidityed) && 
                            (<div>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label" style={{padding:'0'}}>MSA特殊优惠是否从合同额中扣减</label>
                                        <span className="ui-text">{msaSpecialContractReduceShow}</span>
                                    </div>
                                </li>
                                {
                                    isMsaSpecialContractReduceed && (
                                        <div>
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">优惠金额（含税）/人民币</label>
                                                    <span className="ui-text">{discountContractAmount}&nbsp;元
                                                    </span>
                                                </div>
                                            </li>
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">优惠金额（不含税）/人民币</label>
                                                    <span className="ui-text" style={{ width: 186 }}>
                                                        {discountContractAmountNoTaxValue}&nbsp;元
                                                    </span>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                }
                            </div>)
                        }
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">合同开始时间</label>
                                <span className="ui-text">{contractStartDateShow}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">合同结束时间</label>
                                <span className="ui-text">{contractEndDateShow}</span>
                            </div>
                        </li>
                    </div>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">备注</label>
                        <span className="ui-text">{contractRelationSiteComment}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">是否拥有纸质合同</label>
                        <span className="ui-text">{havePaperContractShow}</span>
                    </div>
                </li>
                {
                    config.type == 'approval' ?
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">提前上岗授权函</label>
                                <span className="ui-text">
                                    {(fileList || []).map(i => <a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)}
                                </span>
                            </div>
                        </li>
                    :
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">提前上岗授权函</label>
                                <span className="ui-text">
                                    {(fileList || []).map(i =><a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)}
                                </span>
                            </div>
                        </li>
                }
                <hr style={{ margin: '10px 0' }} />
                {
                    config.type == 'VPApproval'?
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}{config.approvalStatus}</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                    <Radio value='AGREE'>审批通过</Radio>
                                    <Radio value='DISAGREE'>审批不通过</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li> :
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}{config.approvalStatus}</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                    <Radio value='ACTIVE'>审批通过</Radio>
                                    <Radio value='INACTIVE'>审批不通过</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li>
                }
                {
                    (approvalStatus == 'DISAGREE' || approvalStatus == 'INACTIVE') &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}审批不通过原因</label>
                            <span className="ui-text">
                                <Input
                                    placeholder="请输入审批不通过原因"
                                    style={{width: 182}}
                                    value={comments}
                                    onChange={e => this.handleInputChange(e, 'comments')}
                                />
                            </span>
                        </div>
                    </li>
                }
            </div>
        )
    }

    render() {
        const { visible, loading, config } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="cont-cont" style={{padding: '0 20px'}}>
                    <Spin spinning={loading}>
                        <ul className="preview-list apply-jde">
                            { this.getDataList() }
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default ApproveAdvanceWork;



// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/ApproveAdvanceWork.js